<div mat-dialog-content>
    <div class="custom-loader"></div>
    <p>Finalizando pagamento... Aguarde.</p>
</div>